import { Link } from "react-router-dom";
import type { Category } from "@/types/directory";
import CategoryCard from "@/components/base/CategoryCard";

interface PopularCategoriesProps {
  categories: Category[];
}

export default function PopularCategories({ categories }: PopularCategoriesProps) {
  return (
    <section
      id="categories-preview"
      className="border-y border-[#0B3B29] bg-gradient-to-b from-[#0B3B29] to-[#0F5132]"
    >
      <div className="mx-auto w-full max-w-[1400px] px-6 py-16 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="mb-2 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-[#8FE0C0]">
              <span className="h-1 w-1 rounded-full bg-[#8FE0C0]" />
              Browse by category
            </span>
            <h2 className="font-heading text-2xl font-bold leading-tight text-[#EAFBF3] md:text-3xl">
              Popular business categories on the coast
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-[#A9D9C4] md:text-base">
              From authentic Udupi breakfast joints to beach resorts and multispeciality
              hospitals — explore the categories locals and travellers search for the most.
            </p>
          </div>

          <Link
            to="/categories"
            className="group inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-[#CFF1E6] px-4 py-2.5 text-sm font-semibold text-[#0B3B29] transition-colors duration-200 hover:bg-[#E4FAF1]"
          >
            View all categories
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-base transition-transform duration-200 group-hover:translate-x-0.5" />
            </span>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {categories.slice(0, 8).map((category) => (
            <CategoryCard key={category.id} category={category} />
          ))}
        </div>
      </div>
    </section>
  );
}